import { render } from "./PartnerTccView.vue?vue&type=template&id=236db0d7&scoped=true"
import script from "./PartnerTccView.vue?vue&type=script&lang=js"
export * from "./PartnerTccView.vue?vue&type=script&lang=js"

import "./PartnerTccView.vue?vue&type=style&index=0&id=236db0d7&lang=scss&scoped=true"

import exportComponent from "C:\\Projects\\fxhub-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-236db0d7"]])

export default __exports__